import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink, RouterOutlet } from '@angular/router';
import { BreadcrumbsComponent } from '@sdvor/seo/ui';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { IconTypes } from '@shared/v2';
import {
  CurrentProfileComponent,
  LogoutFromAllDevicesComponent,
  LogoutFromCurrentDeviceComponent,
  MyAccountNavigationComponent,
} from '../../components';

@Component({
  selector: 'sd-my-account-page-template',
  templateUrl: './my-account-page-template.component.html',
  styleUrls: ['./my-account-page-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    BreadcrumbsComponent,
    SdvorIconComponent,
    CurrentProfileComponent,
    MyAccountNavigationComponent,
    LogoutFromCurrentDeviceComponent,
    LogoutFromAllDevicesComponent,
    RouterOutlet,
  ],
})
export class MyAccountPageTemplateComponent {
  isTabletUp = toSignal(this.deviceService.isTabletMdUp$);
  iconTypes = IconTypes;

  constructor(private deviceService: DeviceService) {}
}
